var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisconnected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93446 0 0 .93446 .8674 1.7338)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2671,0,0,1.2671,-4.4741,-7.0296)",
    strokeWidth: 18.956
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.41761 0 0 .41761 3.5309 5.5477)",
    d: "m11.537 18.957v13.256c0 4.7179 3.7978 8.5156 8.5156 8.5156h1.4746v3.5234h1.6172v5.75h3.7109v-5.75h1.6172v-3.5234h1.4746c4.7179 0 8.5156-3.7978 8.5156-8.5156v-13.256h-26.926z",
    strokeWidth: 31.472
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.9209 0.97595c-0.74784 0-1.3492 0.60277-1.3492 1.3506v7.0334h11.315v-7.0334c0-0.74784-0.60136-1.3506-1.3492-1.3506h-8.6163zm0.71546 2.6364h1.4704c0.26791 0 0.48449 0.21658 0.48449 0.48449v1.4704c0 0.26791-0.21658 0.48307-0.48449 0.48307h-1.4704c-0.26791 0-0.48307-0.21517-0.48307-0.48307v-1.4704c0-0.26791 0.21517-0.48449 0.48307-0.48449zm5.7152 0h1.4704c0.26791 0 0.48307 0.21658 0.48307 0.48449v1.4704c0 0.26791-0.21517 0.48307-0.48307 0.48307h-1.4704c-0.26791 0-0.48448-0.21517-0.48448-0.48307v-1.4704c0-0.26791 0.21658-0.48449 0.48448-0.48449z",
    stopColor: "#000000",
    strokeWidth: 24.019
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisconnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/disconnected.625ee44a15152d5ea38ddc49a769bc4b.svg";